/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	(function () {
	
	  // let mainImageKasumi = document.getElementById('idx-Main_Box_Image-Kasumi');
	  // let mainImageRan    = document.getElementById('idx-Main_Box_Image-Ran');
	  // let mainImageAya    = document.getElementById('idx-Main_Box_Image-Aya');
	  // let mainImageYukina = document.getElementById('idx-Main_Box_Image-Yukina');
	  // let mainImageKokoro = document.getElementById('idx-Main_Box_Image-Kokoro');
	  //
	  // window.addEventListener('mousemove', (eve) => {
	  //   let windowWidth  = window.innerWidth;
	  //   let windowHeight = window.innerHeight;
	  //   let mouseX = eve.pageX;
	  //   let mouseY = eve.pageY;
	  //   let windowX = (mouseX * 2 - windowWidth) / windowWidth;
	  //   let windowY = (mouseY * 2 - windowHeight) / windowHeight;
	  //   mainImageKasumi.style.transform = 'translateX(calc(-50% + ('+  windowX * -2.5 + 'px))) translateY(' + windowY * -2.5 + 'px)';
	  //   mainImageRan.style.transform    = 'translateX(calc(-50% + ('+  windowX * -10  + 'px))) translateY(' + windowY * -10  + 'px)';
	  //   mainImageAya.style.transform    = 'translateX(calc(-50% + ('+  windowX * -5   + 'px))) translateY(' + windowY * -5   + 'px)';
	  //   mainImageYukina.style.transform = 'translateX(calc(-50% + ('+  windowX * -10  + 'px))) translateY(' + windowY * -10  + 'px)';
	  //   mainImageKokoro.style.transform = 'translateX(calc(-50% + ('+  windowX * -5   + 'px))) translateY(' + windowY * -5   + 'px)';
	  // }, false);
	
	  (0, _module.toggleHeader)();
	
	  (0, _module.drawFooterCurve)();
	
	  (0, _module.visibleTop)();
	
	  (0, _module.anchorAdjust)();
	
	  (0, _module.anchorLink)();
	})();

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var breakPoint = 1023;
	var resizeFlag = false;
	var windowWidth = window.innerWidth;
	var windowHeight = window.innerHeight;
	var windowWidthJ = $(window).width();
	
	// ------------------------------------------------------------------------
	// toggleHeader
	// ----- SP
	// ------------------------------------------------------------------------
	var toggleHeader = function toggleHeader() {
	  var headerFlag = false;
	  var headerButtonOpen = document.getElementById('st-Header_Button_Open');
	  var headerButtonClose = document.getElementById('st-Header_Button_Close');
	  var headerNavigation = document.getElementById('st-Header_Navigation');
	  headerButtonOpen.addEventListener('click', function () {
	    if (!headerFlag) {
	      headerNavigation.classList.remove('st-Header_Navigation-Hidden');
	      headerFlag = true;
	    }
	  }, false);
	  headerButtonClose.addEventListener('click', function () {
	    if (headerFlag) {
	      headerNavigation.classList.add('st-Header_Navigation-Hidden');
	      headerFlag = false;
	    }
	  }, false);
	};
	
	// ------------------------------------------------------------------------
	// drawFooterCurve
	// ----- PC
	// ------------------------------------------------------------------------
	var drawFooterCurve = function drawFooterCurve() {
	  var drawCurve = function drawCurve() {
	    var footer = document.getElementById('st-Footer');
	    var footerCurve = document.getElementById('st-Footer_Curve');
	    var windowWidth = window.innerWidth;
	    var windowWidthRound = Math.round(windowWidth);
	    var windowWidthHalf = windowWidth / 2;
	    var curveHeight = windowWidth * 0.0234375;
	    var curveHeightRound = Math.round(curveHeight);
	    var curveHeightMinus = -1 * curveHeightRound;
	    if (!footerCurve || !footerCurve.getContext) {
	      return false;
	    }
	    (function () {
	      footerCurve.setAttribute('width', windowWidth);
	      footerCurve.setAttribute('height', curveHeightRound);
	      $('#st-Footer').css('margin-top', curveHeightMinus + 'px');
	      $('#st-Footer_Curve').css('top', curveHeightMinus + 'px');
	    })();
	    var ctx = footerCurve.getContext('2d');
	    ctx.beginPath();
	    ctx.moveTo(0, curveHeightRound);
	    ctx.lineTo(windowWidth, curveHeightRound);
	    ctx.quadraticCurveTo(windowWidthHalf, curveHeight * -1, 0, curveHeightRound);
	    ctx.closePath();
	    ctx.fillStyle = '#ff004c';
	    ctx.fill();
	  };
	  window.addEventListener('load', function () {
	    drawCurve();
	  }, false);
	  window.addEventListener('resize', function () {
	    drawCurve();
	  }, false);
	};
	
	// ------------------------------------------------------------------------
	// drawUnderlayerCurve
	// ----- PC
	// ------------------------------------------------------------------------
	var drawUnderlayerCurve = function drawUnderlayerCurve() {
	  var drawCurve = function drawCurve() {
	    var underlayer = document.getElementById('st-Underlayer');
	    var underlayerCurve = document.getElementById('st-Underlayer_Curve');
	    var windowWidth = window.innerWidth;
	    var windowWidthRound = Math.round(windowWidth);
	    var windowWidthHalf = windowWidth / 2;
	    var curveHeight = windowWidth * 0.03125;
	    var curveHeightRound = Math.round(curveHeight);
	    var curveHeightMinus = -1 * curveHeightRound;
	    if (!underlayerCurve || !underlayerCurve.getContext) {
	      return false;
	    }
	    (function () {
	      underlayerCurve.setAttribute('width', windowWidth);
	      underlayerCurve.setAttribute('height', curveHeightRound);
	      $('#st-Underlayer').css('margin-bottom', curveHeightMinus + 'px');
	      $('#st-Underlayer_Curve').css('bottom', curveHeightMinus + 'px');
	    })();
	    var ctx = underlayerCurve.getContext('2d');
	    ctx.beginPath();
	    ctx.moveTo(0, 0);
	    ctx.lineTo(windowWidth, 0);
	    ctx.quadraticCurveTo(windowWidthHalf, curveHeight * 2, 0, 0);
	    ctx.closePath();
	    ctx.fillStyle = '#ffb8cf';
	    ctx.fill();
	  };
	  window.addEventListener('load', function () {
	    drawCurve();
	  }, false);
	  window.addEventListener('resize', function () {
	    drawCurve();
	  }, false);
	};
	
	// ------------------------------------------------------------------------
	// toggleBox
	// ----- BOTH
	// ------------------------------------------------------------------------
	var toggleBox = function toggleBox() {
	  var boxButton = document.getElementsByClassName('st-Box_Button');
	  var boxButtonText = document.getElementsByClassName('st-Box_Button_Text');
	  var boxContents = document.getElementsByClassName('st-Box_Contents');
	
	  var _loop = function _loop(i) {
	    boxButton[i].addEventListener('click', function () {
	      if (boxContents[i].classList.contains('st-Box_Contents-HiddenH') == true) {
	        boxButtonText[i].classList.remove('st-Box_Button_Text-Hidden');
	        boxContents[i].classList.remove('st-Box_Contents-HiddenH');
	        setTimeout(function () {
	          boxContents[i].classList.remove('st-Box_Contents-HiddenO');
	        }, 200);
	      } else {
	        boxButtonText[i].classList.add('st-Box_Button_Text-Hidden');
	        boxContents[i].classList.add('st-Box_Contents-HiddenO');
	        setTimeout(function () {
	          boxContents[i].classList.add('st-Box_Contents-HiddenH');
	        }, 200);
	      }
	    }, false);
	  };
	
	  for (var i = 0; i < boxButton.length; i++) {
	    _loop(i);
	  }
	};
	
	// ------------------------------------------------------------------------
	// visibleTop
	// ----- BOTH
	// ------------------------------------------------------------------------
	var visibleTop = function visibleTop() {
	  var buttonTop = document.getElementById('st-Top');
	  var buttonVisibleHeight = 100;
	  var scrollVolume = 0;
	  window.addEventListener('scroll', function () {
	    if (window.pageYOffset > buttonVisibleHeight) {
	      buttonTop.classList.remove('st-Top-Hidden');
	    } else {
	      buttonTop.classList.add('st-Top-Hidden');
	    }
	  }, false);
	};
	
	// ------------------------------------------------------------------------
	// anchorAdjust
	// ----- BOTH
	// ------------------------------------------------------------------------
	var anchorAdjust = function anchorAdjust() {
	  if (location.hash !== '') {
	    var adjustSpeed = 400;
	    var adjustHref = location.hash;
	    var adjustPosition = 0;
	    var adjustHeight = 0;
	    var targetButton = void 0;
	    $(window).on('load', function () {
	      adjustPosition = $(adjustHref).offset().top;
	      if (windowWidthJ > breakPoint) {
	        adjustHeight = 62;
	      } else {
	        adjustHeight = 0;
	      }
	      if (adjustHref == "#ent-2nd") {
	        targetButton = $(".st-Box_Button")[1];
	      }
	      if (adjustHref == "#ent-Semifinal") {
	        targetButton = $(".st-Box_Button")[2];
	      }
	      setTimeout(function () {
	        targetButton.click();
	        $("html, body").animate({ scrollTop: adjustPosition - adjustHeight }, 800, "swing");
	      }, 50);
	    });
	  }
	};
	
	// ------------------------------------------------------------------------
	// anchorLink
	// ----- BOTH
	// ------------------------------------------------------------------------
	var anchorLink = function anchorLink() {
	  $("a[href^=#]").on("click", function () {
	    var linkSpeed = 800;
	    var linkHref = $(this).attr("href");
	    var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
	    var linkAdjust = 0;
	    var linkPosition = linkTarget.offset().top;
	    if (linkHref == "#round-1st" || linkHref == "#round-2nd" || linkHref == "#round-Semifinal" || linkHref == "#round-Final" || linkHref == "#case-Disqualified" || linkHref == "#out-Regulations" || linkHref == "#ent-2nd" || linkHref == "#ent-Semifinal") {
	      if (windowWidthJ > breakPoint) {
	        linkAdjust = 62;
	      } else {
	        linkAdjust = 0;
	      }
	    }
	    $("html, body").animate({ scrollTop: linkPosition - linkAdjust }, linkSpeed, "swing");
	    return false;
	  });
	};
	
	exports.toggleHeader = toggleHeader;
	exports.drawFooterCurve = drawFooterCurve;
	exports.drawUnderlayerCurve = drawUnderlayerCurve;
	exports.toggleBox = toggleBox;
	exports.visibleTop = visibleTop;
	exports.anchorAdjust = anchorAdjust;
	exports.anchorLink = anchorLink;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index/app.bundle.js